<template>
  <div class="">
    <div
      class="header bg-white  grid grid-cols-[4.25rem,16rem,auto] justify-items-start justify-items-start items-center gap-x-2 p-5"
      v-if="supInfo">
      <img :src="supInfo.logo" class="img rounded-sm" v-if="supInfo.logo">
      <img v-else src="@/assets/image/logo2.png" class="img rounded-sm">
      <span class="text-lg">{{ supInfo.name }}</span>
      <el-rate v-model="supInfo.score" disabled show-score text-color="#ff9900" v-if="supInfo.score">
      </el-rate>
      <div class="flex search">
        <el-input v-model="keyword" class="input "></el-input>
        <el-button class="ml-3" @click="search">{{ $t('搜本店') }}</el-button>
      </div>
    </div>
    <div class="tabs flex justify-start pt-2 cursor-pointer bg-white p-5">
      <span v-for="tab in tabs" :key="tab.key" class="text-xl mr-10 " :class="{ 'active': curTab == tab.key }"
        @click="curTab = tab.key">
        {{ tab.name }}</span>
    </div>
    <div class="wrapper p-5">
      <products v-if="curTab == 'products'" :products="products" @more="changePage" :pager="pager" @sort="sort" :address="address">
      </products>
      <comments v-else-if="curTab == 'comments'" :sid="supid"></comments>
      <info v-else-if="curTab == 'supplier'" :info="supInfo"></info>
    </div>
  </div>
</template>

<script>
import { computed, ref,onMounted } from "@vue/composition-api"
import products from "@/components/store/products.vue"
import info from "@/components/store/info.vue"
import comments from "@/components/store/comments.vue"

export default {
  components: {
    products,
    info,
    comments
  },
  setup(props, ctx) {
    // const logo = ctx.root.$logo
    const supid = ctx.root.$route.query.id
    const user = computed(() => ctx.root.$store.getters.user)

    const keyword = ref()
    const orderby = ref()

    const param = computed(() => {
      let obj = {
        q__supplier_id: supid
      }
      if (orderby.value) {
        obj.orderby = orderby.value
      }
      if (keyword.value) {
        obj.q__name__contains = keyword.value
      }
      return obj
    })
    const address = ref({})
    const products = ref()
    const pager = new ctx.root.$Pager({
      apiname: 'getProductList',
      size: 20,
      param: () => (param.value),
      onLoaded: (res) => {
        if (res.code == 0 && res.data) {
          products.value = res.data
        }
      }
    })
    // const get
    const getLockAddress = async () => {
      // if (!user.value.user_lock_address) {
        await ctx.root.$loadUserInfo()
      // }
        let res = await ctx.root.$callapi('user/getAddress', {
        aid: user.value.user_lock_address
      })
      if (res.code == 0 && res.data) {
        address.value = res.data
      }
    }

    const classifies = ref()
    const getClassify = async () => {
      let res = await ctx.root.$callapi('pre/getClassifyList', {
        q__pproduct__product__supplier_id: supid
      })
      if (res.code == 0 && res.data) {
        classifies.value = res.data
      }
    }

    const supInfo = ref()
    const getSupInfo = async () => {
      let res = await ctx.root.$callapi('sup/getSupplierInfo', {
        la: address.value.latitude,
        lo: address.value.longitude,
        sid: supid
      })
      if (res.code == 0 && res.data) {
        let score = res.data.score
        // if ((score ?? '') !== '') {
        //   res.data.score = Number(score)
        // }
        res.data.score = parseFloat(score)
        supInfo.value = res.data
      }
    }
    const loadData = async () => {
      if (user.value.user_lock_address) {
        await getLockAddress()
        await getSupInfo()
        pager.first()
        getClassify()
      }
    }
    loadData()
    const curTab = ref('products')
    const tabs = [
      {
        key: 'products',
        name: ctx.root.$t('商品')
      },
      {
        key: 'comments',
        name: ctx.root.$t('评价'),
        nums: 0
      },
      {
        key: 'supplier',
        name: ctx.root.$t('商家'),
      }

    ]
    const changePage = async (page) => {
      await pager.load(page)
    }
    const sort = async (val) => {
      orderby.value = val
      await pager.first()
    }
    const search = async () => {
      await pager.first()
    }
    // 
    return { supInfo, keyword, tabs, curTab, products, supid, orderby, pager, changePage, sort, search,address }
  }
}
</script>
<style lang="scss" scoped>.header .img {
  width: 4.25rem;
  height: 4.25rem;
  grid-row: 1/3;
}
.header .search {
  grid-row: 1/3;
  grid-column: 3/4;
}
.header .search .input {
  width: 20rem;
  border-radius: 0.4rem;
}
.tabs>span.active {
  position: relative;
  color: #34B66B;
}
.tabs>span.active::after {
  content: '';
  display: block;
  position: absolute;
  bottom: -0.4rem;
  left: 50%;
  transform: translateX(-50%);
  height: 0.14rem;
  width: 1.57rem;
  background-color: #34B66B;
}</style>